// src/app/_landing/components/EarnSection.tsx
"use client";

import Image from "next/image";

export const EarnSection = () => {
  return (
    <section className="w-full px-4 lg:px-8 py-16 relative overflow-hidden">
      {/* Desktop-only ellipse background */}
      <div className="hidden lg:block absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 flex items-center justify-center">
          <Image
            src="https://pulsarmoney.b-cdn.net/rhuna/ellipse.png"
            alt="Background ellipse"
            width={1200}
            height={600}
            className="object-contain opacity-20"
            priority
          />
        </div>
      </div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Earn with Rhuna
          </h2>
          <p className="text-lg text-white max-w-4xl mx-auto">
            Complete quests, forge items, and climb the leaderboard to earn rewards and unlock exclusive content in the Rhuna ecosystem.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* First Row */}
          <div className="lg:col-span-1">
            {/* Quests Card */}
            <div className="relative rounded-xl overflow-hidden h-64">
              <Image
                src="https://pulsarmoney.b-cdn.net/rhuna/quest_card.png"
                alt="Quests"
                fill
                className="object-cover"
                priority
              />
              {/* Text Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <h3 className="text-2xl font-bold text-white mb-2">Quests</h3>
                <p className="text-sm text-white">
                  Complete daily tasks and challenges to earn points.
                </p>
                <p className="text-sm text-white">
                  Unlock rewards and progress through different tiers.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            {/* Daily Lottery Card */}
            <div className="relative rounded-xl overflow-hidden h-64">
              <Image
                src="https://pulsarmoney.b-cdn.net/rhuna/lottery_card.png"
                alt="Daily Lottery"
                fill
                className="object-cover"
                priority
              />
              {/* Text Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <h3 className="text-2xl font-bold text-white mb-2">Rhuna Forge</h3>
                <p className="text-sm text-white">
                  Craft items and earn rewards through daily forging.
                </p>
                <p className="text-sm text-white">
                  Collect shards and create powerful items.
                </p>
              </div>
            </div>
          </div>

          {/* Second Row */}
          <div className="lg:col-span-2">
            {/* NFT Minting Card */}
            <div className="relative rounded-xl overflow-hidden h-64">
              <Image
                src="https://pulsarmoney.b-cdn.net/rhuna/nft_card.png"
                alt="NFT Minting"
                fill
                className="object-cover"
                priority
              />
              {/* Text Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <h3 className="text-2xl font-bold text-white mb-2">Leaderboard</h3>
                <p className="text-sm text-white">
                  Compete with other players and climb the rankings.
                </p>
                <p className="text-sm text-white">
                  See how you stack up against the community.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            {/* Referrals Card */}
            <div className="relative rounded-xl overflow-hidden h-64">
              <Image
                src="https://pulsarmoney.b-cdn.net/rhuna/referrals_card.png"
                alt="Referrals"
                fill
                className="object-cover"
                priority
              />
              {/* Text Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <h3 className="text-2xl font-bold text-white mb-2">Referrals</h3>
                <p className="text-sm text-white">
                  Invite friends and earn points for each referral.
                </p>
                <p className="text-sm text-white">
                  Both you and your friends benefit from the program.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
